export const profileEditList = [
  { title: "সাধারণ তথ্য", link: "general" },
  { title: "পাসপোর্ট তথ্য", link: "passport" },
  { title: "শিক্ষাগত যোগ্যতা", link: "education" },
  { title: "অন্যান্য টেকনিক্যাল সার্টিফিকেট/লাইসেন্স", link: "technical" },
  { title: "চাকুরীর আভিজ্ঞতা", link: "experience" },
  { title: "সিভি", link: "cv" },
] as const;

export type TProfileEditLink = (typeof profileEditList)[number]["link"];
